import { useState } from 'react';
import { BoxesIcon, PlusIcon, SearchIcon } from 'lucide-react';
import { Tabs } from '../ui/Tabs';
import { EmptyState } from '../ui/EmptyState';
import { btnSecondary, fadeWhileLoading, inputCls, listBox } from '../ui/styles';
import { useStockFilter, type StockControl, type StockFilter } from './useStock';
import { StockRow } from './StockRow';
import { AddConsumableForm } from './AddConsumableForm';
const filters: {
  key: StockFilter;
  label: string;
}[] = [{
  key: 'alles',
  label: 'Alles'
}, {
  key: 'op',
  label: 'Op'
}, {
  key: 'retail',
  label: 'Producten'
}, {
  key: 'verbruik',
  label: 'Verbruik'
}];

/** Tabblad Overzicht: per artikel de stand per plek; open een rij voor acties, inkoopprijs en historie. */
export function StockList({
  stock
}: {
  stock: StockControl;
}) {
  const f = useStockFilter(stock.items);
  const [open, setOpen] = useState<string | null>(null);
  const [adding, setAdding] = useState(false);
  return <>
      {adding ? <AddConsumableForm onCancel={() => setAdding(false)} onDone={item => {
      stock.replace(item);
      setAdding(false);
      setOpen(item.id);
    }} data-id="element-4793" data-mp="3pz0n8ss8yo8v" /> : null}

      <div className="mb-4 flex flex-wrap items-center gap-3" data-id="element-4794" data-mp="2loj5ewz55ly">
        <label className="relative block w-full sm:w-72" data-id="element-4795" data-mp="2oasnk3fdv6t">
          <span className="sr-only" data-id="element-4796" data-mp="7jq465dynf02">Zoeken</span>
          <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" strokeWidth={1.75} aria-hidden="true" data-id="element-4797" data-mp="37069nn4irtua" />
          <input type="search" value={f.query} onChange={e => f.setQuery(e.target.value)} placeholder="Naam of merk" className={`${inputCls} pl-9`} data-id="element-4798" data-mp="3b29wt90jwmve" />
        </label>
        <Tabs variant="pill" label="Filter" tabs={filters} value={f.filter} onChange={f.setFilter} data-id="element-4799" data-mp="3l0h22ulh9ghk" />
        {!adding && <button type="button" onClick={() => setAdding(true)} className={`${btnSecondary} sm:ml-auto`} data-id="element-4800" data-mp="v9u688bi36oy">
            <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-4801" data-mp="1085dqcebp540" />
            Verbruiksartikel
          </button>}
      </div>

      {f.visible.length === 0 ? <EmptyState icon={BoxesIcon} title="Niets gevonden" text={f.filter === 'op' ? 'Niets staat op 0. Mooi.' : 'Probeer een andere zoekterm of filter.'} data-id="element-4802" data-mp="5lopj7hmlk9l" /> : <div className={fadeWhileLoading(stock.status === 'loading')} data-id="element-4803" data-mp="fk4i7ewax1l7">
          <div className="hidden grid-cols-[minmax(0,1fr)_72px_72px_120px_16px] gap-x-4 px-5 pb-2 text-[12px] text-muted sm:grid" aria-hidden="true" data-id="element-4804" data-mp="fitfzjii81w7">
            <span data-id="element-4805" data-mp="3j2fm9tdepfpi">Artikel</span>
            <span className="text-right" data-id="element-4806" data-mp="3j37gazrcv5do">Webshop</span>
            <span className="text-right" data-id="element-4807" data-mp="1l4s02t54emx">Salon</span>
            <span className="text-right" data-id="element-4808" data-mp="1mzc5ewl82py">Verkocht 30 dgn</span>
            <span data-id="element-4809" data-mp="3sysfkq51hrjq" />
          </div>
          <ul className={listBox} aria-label="Voorraad" data-id="element-4810" data-mp="3sxhfb0asz1xd">
            {f.visible.map(item => <StockRow key={item.id} item={item} open={open === item.id} onToggle={() => setOpen(open === item.id ? null : item.id)} onChange={stock.replace} data-id="element-4811" data-mp="357vgidyceopw" />)}
          </ul>
          <p className="mt-4 text-[12px] leading-relaxed text-muted" data-id="element-4812" data-mp="1frj9ln4h8b6e">
            Verkopen boeken zichzelf: een webshopbestelling van de webshopvoorraad, een bon uit de kassa van de salonvoorraad. Op 0 waarschuwt de kassa, maar de verkoop gaat door;
            tel dan opnieuw. "Gebruikt bij de behandeling" bij het afronden in de agenda is alleen een notitie in het dossier en boekt geen voorraad af.
          </p>
        </div>}
    </>;
}